import { TextInput, Textarea } from "@mantine/core";
import { PageList, ENUM_FORM_DISPLAY, ENUM_FORM_LAYOUT_CONTAINER } from "../../components/pageList";
import ActionCellRender from "../../components/actionCellRender";
import { IconTrash, IconPencil } from "@tabler/icons";
import RemarkList from "../../components/remarkList";
import ServiceTypeFieldEditor from "../../components/orderService/ServiceTypeFieldEditor";
import ServiceTypeCompleteUpdatesEditor from "../../components/orderService/ServiceTypeCompleteUpdatesEditor";

const apiEntity = "orderServiceType";

const tableSchema = {
  showActionColumn: true,
  columns: [
    { field: "code", filter: true },
    { field: "name", filter: true },
    { field: "cname", filter: true, headerName: "Chinese Name" },
    {
      field: "action",
      cellRender: ActionCellRender,
      isAction: true,
      actions: [
        {
          name: "edit",
          icon: IconPencil,
          props: {},
        },
      ],
      actionMenu: [
        {
          name: "delete",
          label: "Delete data",
          icon: IconTrash,
          props: {
            color: "red",
          },
        },
      ],
    },
  ],
  searchableFields: ["code", "name", "cname"],
};

const formSchema = {
  title: "Order Service Types",
  display: {
    mode: ENUM_FORM_DISPLAY.LINK,
    size: "xl",
    position: "right",
  },
  apiEntity: "orderServiceType",

  initialValues: {
    code: "",
    name: "",
    cname: "",
    description: "",
    checkList: [],
    fields: [],
    completeOrderUpdates: [],
  },

  validate: {},

  layout: {
    containers: [
      {
        key: "section-basic",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Basic Information",
          description: "Code and display names for this service type",
          mt: 0,
          style: { minHeight: 0 },
        },
      },
      {
        key: "section-checklist",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Checklist",
          description:
            "Documents or items to verify when processing this service",
          style: { minHeight: 0 },
        },
      },
      {
        key: "section-fields",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "Service Fields",
          description:
            "User-input fields collected when creating a service. Wire values to order fields in On Complete — Data Updates below.",
          style: { minHeight: 0 },
        },
      },
      {
        key: "section-complete-updates",
        parent: null,
        type: ENUM_FORM_LAYOUT_CONTAINER.SECTION,
        props: {
          title: "On Complete — Data Updates",
          description:
            "Order fields to update on complete. Use Fixed value for automatic updates (e.g. Terminate → TER). Use Service field value to apply what the user entered (e.g. order status ← New Status A).",
          style: { minHeight: 0 },
        },
      },
    ],
    fields: [
      {
        name: "code",
        parent: "section-basic",
        component: TextInput,
        props: {
          required: true,
          label: "Code",
          placeholder: "OS-CHP",
        },
      },
      {
        name: "name",
        parent: "section-basic",
        component: TextInput,
        props: {
          required: true,
          label: "Name",
          placeholder: "Change of Payment Method",
        },
      },
      {
        name: "cname",
        parent: "section-basic",
        component: TextInput,
        props: {
          label: "Chinese Name",
          placeholder: "",
        },
      },
      {
        name: "description",
        parent: "section-basic",
        component: Textarea,
        props: {
          label: "Description",
          placeholder: "",
          minRows: 3,
        },
      },
      {
        name: "checkList",
        parent: "section-checklist",
        component: RemarkList,
        props: {
          placeholder: "Enter to add checklist item",
        },
      },
      {
        name: "fields",
        parent: "section-fields",
        component: ServiceTypeFieldEditor,
        props: {},
      },
      {
        name: "completeOrderUpdates",
        parent: "section-complete-updates",
        component: ServiceTypeCompleteUpdatesEditor,
        props: {},
      },
    ],
  },
};

function OrderServiceType() {
  return (
    <PageList
      title={"Order Service Types"}
      apiEntity={apiEntity}
      tableSchema={tableSchema}
      formSchema={formSchema}
    />
  );
}

export default OrderServiceType;
